import React from 'react';

function Blocka({ language }) {
  // Content for both English and Hindi
  const content = {
    en: [
      {
        title: "Welcome zone",
        image: "images/main-attractions/block-a/block-a-1.png",
        description: `Behold the magnificent Sudarshan Chakra, an eight ton marvel suspended from the ceiling. Crafted with precision by skilled artisans, it is adorned with thousands of gems, radiating celestial power. A backdrop of cascading water enhances its grandeur, offering visitors a captivating and divine visual experience.`,
        label: "Main Attraction",
      },
      {
        title: "Birth of an Epic",
        image: "images/main-attractions/block-a/block-a-2.png",
        description: `The briefing area features a remarkable projection depicting a dialogue between Ved Vyas and Lord Brahma, focusing on the collection of Vedic knowledge and its dissemination through the creation of the invaluable epic, the Mahabharat. In this divine discourse, Lord Ganesh assumes a pivotal role as the scribe, transcribing the epic as narrated by Ved Vyas.`,
        label: "Main Attraction",
      },
      {
        title: "The Mahabharat Manuscript",
        image: "images/main-attractions/block-a/block-a-3.png",
        description: `This section features a map of Bharatavarsh set in Kurukshetr’s battlefield, marking Janapad alliances with Kauravs and Pandavs. Beside it rests a 700 year old Mahabharat manuscript reproduction, elegantly placed on a pedestal. Complementing it are replicas of Spitzer-script manuscripts, whose originals are preserved in the British Museum.`,
      },
      {
        title: "History of the Kuru Dynasty",
        image: "images/main-attractions/block-a/block-a-4.png",
        description: `This mural illustrates Sage Ved Vyas enunciating the Mahabharat. Depicted within is the lineage of the Lunar dynasty sovereigns, extending from King Buddha to Lord Brahma. It is from this distinguished lineage that the Kuru dynasty is regarded to have its origin.`,
      },
      {
        title: "Soulful Verse of the Gita",
        image: "images/main-attractions/block-a/block-a-5.png",
        description: `Displayed before you is the exalted shloka born from the dialogue between Krishna and Arjun on the battlefield. On beholding his kin in the opposing ranks, Arjun faltered, whereupon Krishna imparted wisdom “perform your duty selflessly, without attachment to reward”. This timeless message continues to serve as a guiding light even today.`,
      },
      {
        title: "Kuru Dynasty Lineage",
        image: "images/main-attractions/block-a/block-a-6.png",
        description: `Here you will witness the lineage of the Kuru dynasty. Beginning with Ganga's son, Bheeshm, it traces the lineage through Dhritarashtr, Pandu and their subsequent heirs. It showcases the succession dispute and jealousy between the brothers, magnified by the ambitions of their sons, ultimately leading to the cataclysmic war of Mahabharat. `,
      },
      {
        title: "The 48-Kos Pilgrimage",
        image: "images/main-attractions/block-a/block-a-7.png",
        description: `This installation captures the 48-kos yatra of Kurukshetr, featuring 18 temples and 4 Yakshas within Haryana. It offers a rich experience through a 3D installation, projection film, murals and an informative kiosk, providing visitors with a deep understanding of the narrative.`,
        label: "Main Attraction",
      },
      {
        title: "Krishna—The Cosmic Guide",
        image: "images/main-attractions/block-a/block-a-8.png",
        description: `This alluring projection screen presents a film where Lord Krishna serves as the narrator, guiding you through the fascinating journey of the creation of the renowned Mahabharat, the 48-kos yatra, and his manifestation on the Kuru Bhumi. Watching this screen immerses you in the teachings and stories shared by Sri Krishna, captivating you in a mesmerizing experience.`,
      },
      {
        title: "Avatars of Vishnu",
        image: "images/main-attractions/block-a/block-a-9.png",
        description: `This ramp is embellished with suspended panels portraying the Avatars of Lord Vishnu, depicting the incarnations of the supreme deity in Hinduism. These avatars symbolize his periodic descents to Earth to maintain harmony in the universe.`,
      },
      // Add other items here...
    ],
    hi: [
      {
        title: "स्वागत कक्ष",
        image: "images/main-attractions/block-a/block-a-1.png",
        description: `यहाँ आपके समक्ष है भव्य सदुर्शन चक्र। आठ टन वजनी यह चक्र छत से निलंबित है। कुशल कारीगरों ने इसे बारीकी से गढ़ा है और हज़ारों रन्नों से अलंकृत किया है। इसकी दिव्य आभा को बहते जल की पृष्ठभूमि और भी मनोहारी बना देती है।`,
        label: "मुख्य आकर्षण",
      },
      {
        title: "महाकाव्य का सृजन",
        image: "images/main-attractions/block-a/block-a-2.png",
        description: `इस चित्र में भगवान ब्रह्मा और वेद व्यास के मध्य होने वाला संवाद प्रदर्शित किया गया है। बातचीत का विषय वैदिक ज्ञान को इकठ्ठा करना और उसको दुनिया में फैलाने के लिए महाभारत जैसे बहुमूल्य काव्य का निर्माण करना है। इस दिव्य प्रवचन में, भगवान गणेश लेखक के रूप में एक महत्वपूर्ण भूमिका निभाते हैं और वेद व्यास द्वारा वर्णित महाकाव्य का प्रतिलेखन करते हैं।`,
        label: "मुख्य आकर्षण",
      },
      {
        title: "महाभारत की प्राचीन पाडुलिपि",
        image: "images/main-attractions/block-a/block-a-3.png",
        description: `इस प्रसंग में कुरुक्षेत्र का युद्धभूमि दश्य है, जिसमें भारतवर्ष का मानचित्र प्रदर्शित है। इसमें महाभारत काल के पांडवों व कौरवों से जुड़े गठबंधन क्षेत्रों को दर्शाया गया है। साथ ही 700 वर्ष पुरानी महाभारत की प्रति और स्पिट्‌ज़र लिपि के दस्तावेज़ों की प्रतिकृतियाँ भी प्रस्तुत हैं।`,
      },
      {
        title: "कुरुवंश का इतिहास",
        image: "images/main-attractions/block-a/block-a-4.png",
        description: `इस भित्ति चित्र में ऋषि वेदव्यास द्वारा महाभारत का वर्णन दर्शाया गया है। इसमें चंद्रवंशी शासकों की वंशावली भी दिखाई गई है, जो राजा बुद्ध से होते हुए भगवान ब्रह्मा तक जाती है। इसी वंश से कुरुवंश की उत्पत्ति मानी जाती है। `,
      },
      {
        title: "दिव्य गीता श्लोक",
        image: "images/main-attractions/block-a/block-a-5.png",
        description: `यहाँ महाभारत का प्रसिद्ध श्लोक प्रस्तुत है, जो युद्धभूमि में कृष्ण और अर्जुन के संवाद से उत्पन्न हुआ। परिवारजन को विरोधी पक्ष में देखकर अर्जुन विचलित हुए, तब कृष्ण ने उपदेश दिया "कर्तव्य निस्वार्थ भाव से करो, फल की चिंता मत करो"। यही संदेश आज भी मार्गदर्शक है।`,
      },
      {
        title: "कुरुवंशावली",
        image: "images/main-attractions/block-a/block-a-6.png",
        description: `यहाँ कुरु राजवंश की वंशावली को प्रदर्शित किया गया है। गंगा के पुत्र भीष्म से शुरू होकर, यह धृतराष्ट्र, पांडु और उनके बाद के उत्तराधिकारियों के माध्यम से आगे बढ़ती है। यह भाइयों के बीच उत्तराधिकार विवाद और ईर्ष्या को दर्शाता है, जो उनके बेटों की महत्वाकांक्षाओं से बढ़ जाता है, जो अतंतः महाभारत के विनाशकारी युद्ध की ओर ले जाता है।`,
      },
      {
        title: "48–कोस की परिक्रमा",
        image: "images/main-attractions/block-a/block-a-7.png",
        description: `यह स्थापना कुरुक्षेत्र की 48-कोस यात्रा का सार प्रस्तुत करती है, जिसमें हरियाणा की सीमाओं के भीतर 18 मंदिर और 4 यक्ष शामिल हैं। इसमें त्रिआयामी चित्र, प्रोजेक्शन फिल्म, भित्ति चित्र तथा सूचनात्मक कियोस्क जैसे तत्व दर्शकों को गहन अनुभव प्रदान करते हैं।`,
        label: "मुख्य आकर्षण",
      },
      {
        title: "कृष्ण—नियति का सारथी",
        image: "images/main-attractions/block-a/block-a-8.png",
        description: `यह आकर्षक प्रोजेक्शन स्क्रीन एक फिल्म प्रस्तुत करती है जहाँ भगवान कृष्ण वाचक के रूप में आपको महाभारत की रचना की रोमांचक यात्रा, 48-कोस यात्रा, और कुरु भूमि पर उनके अवतरण के विषय में मार्गदर्शन करते हैं। यहाँ आप श्री कृष्ण द्वारा साझा की गई शिक्षाओं और कहानियों में डूब जाते हैं, जो आपको एक मंत्रमुग्ध कर देने वाले अनुभव की ओर ले जाती है।`,
      },
      {
        title: "विष्णु के अवतार",
        image: "images/main-attractions/block-a/block-a-9.png",
        description: `यह स्थल भगवान विष्णु के अवतारों को चित्रित करने वाले निलंबित चित्रफलकों से अलंकृत है, जो हिन्दू धर्म में सर्वोच्च देवता के अवतारों का विवरण करता है। भगवान विष्णु के यह अवतार ब्रह्मांड में सद्भाव बनाए रखने के लिए पृथ्वी पर उनके आवधिक अवतरण का प्रतीक है।`,
      },
    ],
  };

  return (
    <div className="main_attractions_list">
      {content[language].map((item, index) => (
        <div className="list_item" id={`ma-blocka-${index}`} key={index}>
          <div className="attraction_image">
            <img src={item.image} alt={item.title} />
          </div>
          <div className="attranction_details">
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            {item.label && <span className="main-attraction-label">{item.label}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Blocka;
